import { announcementSlice } from "components/store/reducers/shared/announcementReducer";

export const { broadcastAnnouncement } = announcementSlice.actions;
